<template>
<div class="content">
  <div class="header">
    <div style="margin-bottom: 10px">
<!--      <el-button type="primary" size="mini" @click="houseLegalToTempByHouseIds()">批量添加</el-button>-->
<!--      <el-button type="primary" size="mini" @click="houseLegalToTemp()">全部添加</el-button>-->

      <el-button size="mini" v-if="ERP.isPermission(8007001006)" @click="exportExcel(1)">导出欠费房产</el-button>
      <!--    <el-button size="mini" @click="exportExcel(2)">导出房产（催缴房产）</el-button>-->
      <!--    <el-button size="mini" @click="importLegalHouseExcel">导入催缴房产</el-button>-->
    </div>
    <div style="margin-bottom: 10px">
      <el-select size="mini" placeholder="账龄类型" clearable v-model="where2.age">
        <el-option v-if="showAgeType.includes(1)" :value="1" label="当期"></el-option>
        <el-option v-if="showAgeType.includes(2)" :value="2" label="纯上一年"></el-option>
        <el-option v-if="showAgeType.includes(3)||showAgeType.includes(5)" :value="3" label="1年以上2年以内"></el-option>
        <el-option v-if="showAgeType.includes(4)||showAgeType.includes(5)" :value="4" label="2年以上"></el-option>
<!--        <el-option v-if="showAgeType.includes(5)" :value="5" label="1年以上"></el-option>-->
      </el-select>
      <el-date-picker
        style="width: 120px"
        v-model="where2.qf_time"
        size="mini"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" placeholder="欠费月份">
      </el-date-picker>
      <el-date-picker
        style="width: 120px"
        v-model="where2.last_month"
        size="mini"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" placeholder="上次缴费月份">
      </el-date-picker>
<!--      <el-select size="mini" placeholder="上次缴费方式" clearable v-model="where2.cur_month_times" style="width: 120px;">-->
<!--        <el-option :value="0" label="暂未催费"></el-option>-->
<!--        <el-option :value="1" label="1次催费"></el-option>-->
<!--        <el-option :value="2" label="2次催费"></el-option>-->
<!--        <el-option :value="3" label="3次催费"></el-option>-->
<!--        <el-option :value="4" label="多次催费"></el-option>-->
<!--      </el-select>-->
      <el-date-picker
        style="width: 150px"
        v-model="where2.gj_time"
        size="mini"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd" placeholder="跟进日期">
      </el-date-picker>
      <el-input clearable placeholder="欠费月数" v-model="where2.month_count" style="width: 100px" size="mini"></el-input>
      <el-select size="mini" placeholder="月催费次数" clearable v-model="where2.cur_month_times" style="width: 120px;">
        <el-option :value="0" label="暂未催费"></el-option>
        <el-option :value="1" label="1次催费"></el-option>
        <el-option :value="2" label="2次催费"></el-option>
        <el-option :value="3" label="3次催费"></el-option>
        <el-option :value="4" label="多次催费"></el-option>
      </el-select>
      <el-select size="mini" placeholder="年催费次数" clearable v-model="where2.cur_year_times" style="width: 120px;">
        <el-option :value="0" label="暂未催费"></el-option>
        <el-option :value="1" label="1次催费"></el-option>
        <el-option :value="2" label="2次催费"></el-option>
        <el-option :value="3" label="3次催费"></el-option>
        <el-option :value="4" label="多次催费"></el-option>
      </el-select>
      <el-select size="mini" placeholder="选择房态" clearable v-model="where2.room_status" style="width: 120px;">
        <el-option :value="1" label="空置"></el-option>
        <el-option :value="2" label="未领"></el-option>
        <el-option :value="3" label="空关"></el-option>
        <el-option :value="4" label="装修"></el-option>
        <el-option :value="5" label="入住"></el-option>
        <el-option :value="6" label="出租"></el-option>
        <el-option :value="7" label="停用"></el-option>
      </el-select>
      <el-select size="mini" placeholder="欠费类型" clearable v-model="where2.arrears_level1" style="width: 180px;" @change="changeArrearsLevel1">
        <el-option v-for="(item, index) in arrears_arr" :key="index" :value="item.id" :label="item.name"></el-option>
      </el-select>
      <el-select size="mini" placeholder="欠费类型-原因" clearable v-model="where2.arrears_level2" style="width: 180px;">
        <el-option v-for="(item, index) in arrears_arr_children" :key="index" :value="item.id" :label="item.name"></el-option>
      </el-select>
      <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>
    </div>
  </div>
  <div>
    <header-tip>
      催费房产数：{{pageData.total}} &nbsp;&nbsp;&nbsp;&nbsp;
    </header-tip>
    <header-tip v-if="lossLegalHouseCountObject.type_current_1_count>0||lossLegalHouseCountObject.type_current_2_count>0||lossLegalHouseCountObject.type_current_3_count>0||lossLegalHouseCountObject.type_current_4_count>0">
      <span v-if="lossLegalHouseCountObject.type_current_1_count>0">当期：{{formatMoney(lossLegalHouseCountObject.type_current_1_money)}} 元 （{{lossLegalHouseCountObject.type_current_1_count}} 户）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span v-if="lossLegalHouseCountObject.type_current_2_count>0">纯上一年：{{formatMoney(lossLegalHouseCountObject.type_current_2_money)}} 元 （{{lossLegalHouseCountObject.type_current_2_count}} 户）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span v-if="lossLegalHouseCountObject.type_current_3_count>0">1年以上2年以内：{{formatMoney(lossLegalHouseCountObject.type_current_3_money)}} 元 （{{lossLegalHouseCountObject.type_current_3_count}} 户）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span v-if="lossLegalHouseCountObject.type_current_4_count>0">2年以上：{{formatMoney(lossLegalHouseCountObject.type_current_4_money)}} 元 （{{lossLegalHouseCountObject.type_current_4_count}} 户）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    </header-tip>
  </div>
  <AgeTip
    :project_id="reginWhere.project_name"
    :project_ids="reginWhere.project_ids"
    :ages="showAgeType.includes(5)?[5]:[1,2,5]"
  >
  </AgeTip>
  <div class="header-tip" v-if="selectCount>0">
    <span v-if="selectCount>0">选择房产数：{{selectCount}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectDebtAmount>0">欠费金额：{{formatMoney(selectDebtAmount,2)}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount1>0">当期数量：{{selectCount1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount2>0">纯上一年数量：{{selectCount2}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="(selectCount3+selectCount4)>0">一年以上：{{selectCount3+selectCount4}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
  </div>
  <div class="body">
    <div>
      <div class="table-wrap">
        <el-table
          ref="tableRef"
          v-loading="loading" :data="pageData.list"
          row-key="ch_md5"
          border
          stripe
          style="width: 100%"
          height="50vh"
          @sort-change="onSorTable"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45" fixed></el-table-column>
          <el-table-column
            prop="房产信息"
            label="房产信息" width="320" fixed sortable="custom"></el-table-column>
          <el-table-column
            prop="区域"
            label="区域"
            width="90" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="业主"
            label="业主姓名"
            width="220" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="业主电话"
            label="业主电话"
            width="150" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="房态"
            label="房态"
            width="80" sortable="custom">
          </el-table-column>
          <el-table-column
            label="银行划扣"
            width="90">
            <template slot-scope="scope">
              <span style="color: #328628" v-if="scope.row.bankType">是</span>
              <span v-if="!scope.row.bankType"></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="欠费起始月份"
            label="欠费起始月份"
            width="120" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="欠费月数"
            label="欠费月数"
            width="100" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="欠费金额/诉讼金额"
            label="欠费金额/诉讼金额"
            width="150" sortable="custom">
            <template slot-scope="scope">
              <el-link v-if="scope.row['催缴类型']!=='诉讼'" type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row['欠费金额'] }}</el-link>
              <span v-if="scope.row['催缴类型']==='诉讼'">{{scope.row['诉讼金额']}}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="计划催缴月份"-->
          <!--            label="计划催缴月份"-->
          <!--            width="100" sortable="custom">-->
          <!--          </el-table-column>-->
          <!--          <el-table-column-->
          <!--            prop="催缴类型"-->
          <!--            label="催缴类型"-->
          <!--            width="90" sortable="custom">-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="账龄类型"
            label="账龄类型"
            width="100" sortable="custom">
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="第三方合作单位"-->
          <!--            label="第三方合作单位"-->
          <!--            width="150" sortable="custom">-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="缴费类型"
            label="缴费类型"
            width="100" sortable="custom">
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="上次缴费时间"-->
          <!--            label="上次缴费时间"-->
          <!--            width="170">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-link type="primary" size="mini" @click="getLastHouseBill(scope.row)">{{ scope.row['上次缴费时间'] }}</el-link>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="上次成功缴费方式"
            label="上次成功缴费方式"
            width="200" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="上次缴费时间"
            label="上次缴费时间"
            width="170" sortable="custom"></el-table-column>
          <!--          <el-table-column-->
          <!--            prop="第一次催费时间"-->
          <!--            label="第一次催费时间"-->
          <!--            width="150">-->
          <!--          </el-table-column>-->
          <!--          <el-table-column-->
          <!--            prop="第二次催费时间"-->
          <!--            label="第二次催费时间"-->
          <!--            width="150">-->
          <!--          </el-table-column>-->
          <!--          <el-table-column-->
          <!--            prop="第三次催费时间"-->
          <!--            label="第三次催费时间"-->
          <!--            width="150">-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="one_gj_time"
            label="第一次催费跟进时间"
            width="160" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="two_gj_time"
            label="第二次催费跟进时间"
            width="160" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="three_gj_time"
            label="第三次催费跟进时间"
            width="160" sortable="custom">
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="催费次数"-->
          <!--            label="催费次数"-->
          <!--            width="90">-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="cur_month_times"
            label="月催费次数"
            width="100" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="cur_year_times"
            label="年催费次数"
            width="100" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="欠费类型"
            label="欠费类型"
            width="150" sortable="custom">
            <template slot-scope="scope">
              <span v-if="scope.row['欠费类型']">{{scope.row['欠费类型']}}</span>
              <span v-if="scope.row['欠费类型原因']"> ： {{scope.row['欠费类型原因']}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="欠费原因"-->
<!--            label="欠费原因"-->
<!--            width="150">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="业主诉求"
            label="业主诉求"
            width="150">
          </el-table-column>
          <el-table-column
            prop="解决措施"
            label="催费措施"
            width="150">
          </el-table-column>
          <el-table-column
            prop="备注"
            label="备注"
            width="200">
          </el-table-column>
          <el-table-column
            label="操作"
            width="100" fixed="right">
            <template slot-scope="scope">
              <!--              <el-button type="primary" size="mini" @click="editType(scope.row)">变更催缴</el-button>-->
              <!--              <el-link type="primary" @click="openFlow(scope.row)">审批流程</el-link>&nbsp;&nbsp;&nbsp;&nbsp;-->
              <!--              <el-button type="danger" size="mini" @click="delHouse(scope.row)">移除</el-button>-->
<!--              <el-button type="primary" size="mini" @click="addLegalHouse(scope.row)">添加</el-button>-->
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="sizes,total,prev, pager, next"
          :total="pageData.total*1"
          :page-size="pageData.pageSize*1"
          :current-page="pageData.page*1"
          @current-change="pageChange"
          @size-change="handleSizeChange"
          :page-sizes="[15,20,50,100, 200, 300, 400,500,1000]"></el-pagination>
      </div>
    </div>
    <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="催缴类型">
            <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
              <el-option value="自催" label="自催"></el-option>
              <el-option value="诉讼" label="诉讼"></el-option>
              <el-option value="第三方" label="第三方"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="计划催缴月份">
            <el-date-picker
              style="width: 150px"
              v-model="from_data['计划催缴月份']"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="onClose">关 闭</el-button>
          <el-button @click="editTypeSubmit">修 改</el-button>
        </div>
      </template>
    </el-dialog>



    <el-dialog title="最后一次缴费明细" :visible.sync="dialogVisible_2" :close-on-click-modal="false" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ house_bill_order_2['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ house_bill_order_2['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ house_bill_order_2['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ house_bill_order_2['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ house_bill_order_2['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ house_bill_order_2['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ house_bill_order_2['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_2=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
  <ViewFile ref="ViewFile" />
  <ViewFlow ref="viewFlowRef" />
  <LegalHouseMoneyList ref="legalHouseMoneyListRef" />

<!--  <el-drawer-->
<!--    :visible.sync="drawer"-->
<!--    :with-header="false"-->
<!--    size="90%">-->
<!--    <LegalHousePlanTemp v-if="drawer" />-->
<!--  </el-drawer>-->
</div>
</template>

<script>
import Http from "../../common/Http";
import moment from "moment/moment";
import ViewFile from "../../../Common/ViewFile";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";
import LegalHousePlanTemp from "./LegalHousePlanTemp";
import AgeTip from "../common/AgeTip";
import LegalHouseMoneyList from "../LegalHouseMoneyList";
import TableData from "../../common/TableData";
import HeaderTip from "../../../Common/header-tip";

export default {
  name: "LossLegalHousePlan",
  components: {HeaderTip, LegalHouseMoneyList, AgeTip, LegalHousePlanTemp, ViewFlow, ViewFile},
  props:{
    isNotPlan:{
      type: Boolean,
      default: false
    },
    showAgeType:{
      type: Array,
      default: ()=>{
        return [1,2,3,4]
      }
    },
  },
  inject:['where','reginWhere'],
  data(){
    return{
      where2:{
        urge_type:"",
        age:"",
        type:"",
        cur_month_times:"",
        cur_year_times:"",
        qf_time:moment().format("YYYY-MM"),
        jh_time:"",
        last_month:"",
        house_name:"",
        room_status:"",
        arrears_level1:'',
        arrears_level2:'',
        gj_time:"",
        month_count:"",
        order_by:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      from_data:{},
      dialogVisible:false,
      dialogVisible_2:false,
      house_bill_order_2:{},
      multipleSelection:[],
      multipleSelection2:[],
      drawer:false,
      arrears_arr:[],
      arrears_arr_children:[],
      lossLegalHouseCountObject:{
        type_current_1_count: 0,
        type_current_2_count: 0,
        type_current_3_count: 0,
        type_current_4_count: 0,
        type_current_1_money: 0,
        type_current_2_money: 0,
        type_current_3_money: 0,
        type_current_4_money: 0,
      },
    }
  },
  mounted() {
    const that=this;
    this.pageChange(1);
    this.getArrearsArr();
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.urge_type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.qf_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_month_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_year_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.room_status":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level1":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level2":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.last_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.gj_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.month_count":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  computed:{
    ch_md5s(){
      return this.multipleSelection.map(ret=>ret.ch_md5)
    },
    selectCount(){
      return this.multipleSelection.length
    },
    selectCount1(){
      return this.multipleSelection.filter(ret=>ret['账龄类型']==='当期').length
    },
    selectCount2(){
      return this.multipleSelection.filter(ret=>ret['账龄类型']==='纯上一年').length
    },
    selectCount3(){
      return this.multipleSelection.filter(ret=>ret['账龄类型']==='1年以上2年以内').length
    },
    selectCount4(){
      return this.multipleSelection.filter(ret=>ret['账龄类型']==='2年以上').length
    },
    selectDebtAmount(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur['欠费金额']||0)*1)
      },0)
    },
    selectLawsuitAmount(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur['诉讼金额']||0)*1)
      },0)
    },
    tableKey(){
      return (this.reginWhere.project_name||0)+"-"+(this.where2.age||0)+"-"+this.pageData.page
    }
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      if(!that.where2.age&&that.showAgeType.includes(5)){
        where.age=5;
      }

      ButlerHttp.post(that.isNotPlan?"LegalHouse/getLossLegalHouseNotPlanList":"LegalHouse/getLossLegalHouseList",{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
          // setTimeout(function () {
          //   TableData.getInstance().selected(that,that.tableKey,that.pageData.list);
          // },500)
        }
        that.loading = false;
      })
      if(that.pageData.page===1){
        that.getLossLegalHouseCountObject();
      }
    },
    getLossLegalHouseCountObject(){
      const that = this;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      if(!that.where2.age&&that.showAgeType.includes(5)){
        where.age=5;
      }

      ButlerHttp.post(that.isNotPlan?"LegalHouse/getLossLegalHouseNotPlanCountObject":"LegalHouse/getLossLegalHouseCountObject",{
        ...where,
      }, res => {
        if (res.code) {
          that.lossLegalHouseCountObject = res.data;
        }
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);
    },
    getArrearsArr(){
      const that=this;
      ButlerHttp.get("Legal/getArrearsArr",{},ret=>{
        if(ret.code){
          that.arrears_arr=ret.data;
        }
      })
    },
    handleSizeChange(i){
      const that=this;
      that.pageData.pageSize = i;
      that.pageChange(1);
    },
    exportExcel(type=1) {
      const that = this;
      console.log(that.reginWhere.project_name)
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        ...that.where2,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      if(type===2){
        where={
          ...where,
          ...that.where2,
          area_id:that.reginWhere.area_id
        }
      }
      if(!that.where2.age&&that.showAgeType.includes(5)){
        where.age=5;
      }
      ButlerHttp.post(type===1?"Legal/getLegalHouseExcel2":"Legal/getLegalHouseExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    importLegalHouseExcel(){
      const that=this;
      Http.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("Legal/importLegalHouseToFlow", {
          file: file
        }, res => {
          loading.close();
          if (res.code) {
            let timeStr = new Date().getTime();
            ERP.navigateTo(`/flow/FlowView?sheet_id=140&master_id=114&timeValue=${timeStr}&batch_number=${res.data}`);
            // that.pageChange(1);
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    editType(item){
      const that=this;
      that.from_data=item;
      that.dialogVisible=true;
    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={}
    },
    addLegalHouse(item){
      const that=this;
      that.loading = true;

      ButlerHttp.post("LegalHouse/lossHouseLegalToTempByHouseIds",{
        project_id:item['项目ID'],
        ch_md5s:item.ch_md5,
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("操作成功")
          // that.pageChange(1);
          that.$emit("onAdd",{})
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    houseLegalToTempByHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/lossHouseLegalToTempByHouseIds",{
        projectId:that.reginWhere.project_name,
        ch_md5s:that.ch_md5s.join(','),
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("操作成功")
          that.$emit("onAdd",{})
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    houseLegalToTemp(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/lossHouseLegalToTemp",{
        ...where,
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$emit("onAdd",{})
        }else {
          that.$message.error(res.msg);
        }
      });
    },
    editTypeSubmit(){
      const that=this;
      let urge_type_obj={
        '自催':1,
        '诉讼':2,
        '第三方':3
      }
      ButlerHttp.post("Legal/updateLegalHouseType", {
        id: that.from_data.id,
        ch_md5: that.from_data.ch_md5,
        urge_type: urge_type_obj[that.from_data['催缴类型']],
        year_month: that.from_data['计划催缴月份']
      }, res => {
        if (res.code) {
          that.onClose();
          that.$message.success("操作成功");
          that.pageChange(1);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getHouseBill(item){
      const that=this;
      // projectId: item.PrecinctID,
      //   houseId: item.HouseID
      that.$refs.legalHouseMoneyListRef.show({
        project_id:item.PrecinctID,
        house_id:item.HouseID,
      })

    },
    getLastHouseBill(item){
      const that=this;
      ButlerHttp.post("Legal/getLastHouseBill", {
        projectId: item['项目ID'],
        houseId: item['房产ID'],
        last_time: item['上次缴费时间']
      }, res => {
        if (res.code) {
          that.dialogVisible_2 = true;
          that.house_bill_order_2 = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    delHouse(item){
      const that=this;
      that.$confirm(`您将要移除该【${item['房产信息']}】欠费房产，移除后将不再显示该房产的欠费计划，包含自催、诉讼和第三方管理。您确定操作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("Legal/delHouseUrge", {
          projectId: item['项目ID'],
          ch_md5: item.ch_md5
        }, res => {
          if (res.code) {
            that.$message.success(res.msg);
            that.getList();
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    handleSelectionChange(val) {
      const that=this;
      that.multipleSelection = val;
      // console.log('========>>>',that.tableKey,val.length);
      // TableData.getInstance().setList(that.tableKey,val)
      // console.log(TableData.getInstance().getTableData())
    },
    delHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.$confirm(`您将要移除这些欠费房产，移除后将不再显示该房产的欠费计划，包含自催、诉讼和第三方管理。您确定操作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("Legal/delHouseUrge", {
          projectId: that.reginWhere.project_name,
          ch_md5s: that.ch_md5s.join(',')
        }, res => {
          if (res.code) {
            that.$message.success(res.msg);
            that.getList();
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
    changeArrearsLevel1(id){
      const that=this;
      let arrears_index=that.arrears_arr.findIndex(ret=>ret.id===id)
      if(arrears_index!==-1){
        that.arrears_arr_children=that.arrears_arr[arrears_index].children||[];
        that.where2.arrears_level2='';
      }else {
        that.arrears_arr_children=[];
        that.where2.arrears_level2='';
      }
    },
    onSorTable({column, prop, order}){
      console.log({column, prop, order})
      const that=this;
      if(order){
        let orderProp={
          "房产信息":"h.ancestor_name",
          "区域":"ah.house_name",
          "业主":"ar.name",
          "业主电话":"ar.phone",
          "房态":"ar.room_status",
          "欠费起始月份":"ar.fees_begin_time",
          "欠费月数":"ar.moneyMonth",
          "欠费金额/诉讼金额":"ar.moneyTypeSum",
          // "计划催缴月份":"",
          "账龄类型":"ar.type_current",
          // "第三方合作单位":"",
          // "催缴类型":"",
          "上次成功缴费方式":"r.payed_last_way",
          "上次缴费时间":"ar.payed_last_time",
          "one_gj_time":"r.one_gj_time",
          "two_gj_time":"r.two_gj_time",
          "three_gj_time":"r.three_gj_time",
          "cur_month_times":"uh.cur_month_times",
          "cur_year_times":"uh.cur_year_times",
          "欠费类型":"r.arrears_type",
        }
        let sortOrder = order === 'ascending' ? 'asc' : 'desc'; // 转换为后端期望的格式（例如 'asc'/'desc'）
        let field=orderProp[prop]||null
        if(field) {
          that.where2.order_by=`${field} ${sortOrder}`
        }else {
          that.where2.order_by=''
        }
      }else {
        that.where2.order_by=''
      }
      that.pageChange(1);

    },
  }
}

</script>

<style lang="scss">
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
  .pagination-wrap{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LossLegalHousePlan.vue